<template>
  <CoreButtonBase v-bind="$attrs">
    <slot />
  </CoreButtonBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CoreButtonBase from './CoreButtonBase.vue'

export default defineComponent({
  components: {
    CoreButtonBase,
  },
})
</script>

<style lang="scss" scoped></style>
